var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97001 4.93231C7.97001 4.49858 8.32162 4.14697 8.75535 4.14697H18.9647C19.3984 4.14697 19.75 4.49858 19.75 4.93231V16.7123C19.75 17.146 19.3984 17.4976 18.9647 17.4976H8.75535C8.32162 17.4976 7.97001 17.146 7.97001 16.7123V4.93231ZM9.54068 5.71764V15.927H18.1793V5.71764H9.54068ZM6.39935 6.50297C6.83307 6.50297 7.18468 6.85458 7.18468 7.28831V18.283H16.6087C17.0424 18.283 17.394 18.6346 17.394 19.0683C17.394 19.502 17.0424 19.8536 16.6087 19.8536H6.39935C5.96562 19.8536 5.61401 19.502 5.61401 19.0683V7.28831C5.61401 6.85458 5.96562 6.50297 6.39935 6.50297Z",
    fill: "#0088C6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.4eb29d2893164e80faf317d88a916734.svg";
export { ForwardRef as ReactComponent };